import { createFileRoute } from '@tanstack/react-router'
import { Header } from '@/components/Header'
import { Footer } from '@/components/Footer'
import { SupportChannelGrid } from '@/features/company-pages/components/SupportChannelGrid'
import { PageHero } from '@/shared/components/marketing/PageHero'
import { generateLinks, generateMetaTags, routeSEO } from '@/lib/seo'

export const Route = createFileRoute('/support')({
  head: () => ({
    meta: generateMetaTags(routeSEO['/support']),
    links: generateLinks(routeSEO['/support']),
  }),
  component: SupportPage,
})

function SupportPage() {
  return (
    <div className="relative flex min-h-screen flex-col overflow-x-clip bg-[var(--color-bg-primary)]">
      <Header />

      <main className="flex-1">
        <PageHero
          eyebrow="Contact"
          title="Support"
          lede="Get in touch with us through any of the channels below."
        />
        <SupportChannelGrid />
      </main>

      <Footer />
    </div>
  )
}
